<app-dialog-basic dialogTitle="Wordファイルをダウンロード">
  <div class="text-md pb-4">
    <div>Wordファイルのダウンロードを開始します。</div>
  </div>

  <app-alert-box type="warning" [closeable]="false" alignItems="flex-start">
    <p class="text-md mb-1"><strong>Microsoft Edge ブラウザをご利用の方へ</strong></p>
    <p class="text-sm">
      「アクセス許可がありません」と表示されたら、以下の手順で設定を変更してください。
    </p>
    <div class="bg-white/80 p-3 rounded-md mt-2 text-sm border border-warning-200">
      <span class="font-bold">右上［…］</span>
      →
      <span class="font-bold">設定</span>
      →
      <span class="font-bold">ダウンロード</span>
      →
      <span class="font-bold">「Officeファイルをブラウザーで開く」</span>
      をオフにする
    </div>

    <div class="flex items-center mt-2">
      <div class="text-center">
        <mat-icon class="icon text-md w-[0.75rem] h-[0.75rem]" aria-hidden="false" aria-label="">keyboard_arrow_right</mat-icon>
        <a href="/help#faq-7" target="_blank" class="underline hover:no-underline text-sm">
          詳しくはこちら
        </a>
      </div>
    </div>
  </app-alert-box>

  <app-dialog-basic-footer>
    <div class="ml-2 mr-auto">
      <mat-checkbox color="primary" [(ngModel)]="doNotShowAgain">今後は表示しない</mat-checkbox>
    </div>
    <button mat-stroked-button (click)="cancel()" [disabled]="disabled">キャンセル</button>
    <button mat-flat-button color="primary" (click)="downloadWord()" [disabled]="disabled">ダウンロード</button>
  </app-dialog-basic-footer>
</app-dialog-basic>
